var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"sfc-main-container"}},[_c('sfc-menu'),_c('sfc-menu-mobile',{staticClass:"menu-mobile"}),_c('div',{attrs:{"id":"sfc-main-content"}},[_c('nuxt')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }